<template lang="pug">
  footer.footer(v-lazyload)
    .container
      .footer__content
        .footer__copyright(v-if="!isRussia")
          span © {{ year }},
          span «{{ copyrightText }}»
        HeaderSocials
        .footer__address(v-if="!isRussia")
          span {{ addressUpperText }}
          span {{ addressLowerText }}
      .footer__disclaimer(v-if="isRussia")
        span {{ $t('disclaimer') }}
</template>

<script>
import HeaderSocials from '@/components/header/HeaderSocials'
import { mapState } from 'vuex'

export default {
  name: 'Footer',
  components: {
    HeaderSocials
  },
  data: () => ({
    year: new Date().getFullYear()
  }),
  computed: {
    ...mapState('siteVersions', {
      isRussiaCountry: state => state.item?.code === 'ru'
    }),
    isRussia: vm => vm.isRussiaCountry && vm.$i18n.locale === 'ru',
    copyrightText: () => 'Gorilla Drinks Limited',
    addressUpperText: () => 'Arch.Makariou III, 212 SETA COURT',
    addressLowerText: () => 'flatloffice 12/1, 3030, Limassol, Cyprus'
  }
}
</script>
